import { render, staticRenderFns } from "./approvelist.vue?vue&type=template&id=5986bb87&scoped=true"
import script from "./approvelist.vue?vue&type=script&lang=js"
export * from "./approvelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5986bb87",
  null
  
)

export default component.exports